module.exports = __webpack_public_path__ + "img/guanjian2.02930973.webp";